import styled from 'styled-components';

export const LoginPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: var(--vo-mist);
`;

export const LoginCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 16px 40px color-mix(in srgb, var(--vo-escuro) 10%, transparent), 0 4px 8px color-mix(in srgb, var(--vo-escuro) 6%, transparent);
  padding: 44px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const LoginHeading = styled.div`
  text-align: center;

  h1 {
    font-family: 'Rubik', sans-serif;
    font-size: 26px;
    font-weight: 700;
    color: var(--vo-ink);
    margin: 0 0 8px;
    letter-spacing: -0.02em;
  }

  p {
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    color: var(--vo-slate);
    margin: 0;
    line-height: 1.55;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink-2);
`;


export const FieldError = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-danger);
`;

export const SubmitButton = styled.button`
  height: 48px;
  background: var(--color-brand);
  color: white;
  border: none;
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;

  &:hover:not(:disabled) {
    background: var(--color-brand-strong);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FooterText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-slate);
  text-align: center;
  margin: 0;

  button {
    border: none;
    background: transparent;
    color: var(--vo-celeste);
    font-weight: 500;
    cursor: pointer;
    padding: 0;
    font-size: inherit;
    font-family: inherit;

    &:hover {
      color: var(--vo-cobalto);
    }
  }
`;
